// import { createContext, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import Toast from "../pages/Tost"; // Import your Toast component

// export const ShopContext = createContext();

// const ShopContextProvider = (props) => {
//   const currency = "₹";
//   const delivery_fee = 0;
//   const backendUrl = import.meta.env.VITE_BACKEND_URL; // Backend URL from environment
//   const [search, setSearch] = useState("");
//   const [showSearch, setShowSearch] = useState(false);
//   const [cartItems, setCartItems] = useState({});
//   const [products, setProducts] = useState([]);
//   const [token, setToken] = useState("");
//   const [userData, setUserData] = useState(null); // Add userData state
//   const [toast, setToast] = useState({ message: "", type: "", visible: false }); // Toast state
//   const navigate = useNavigate();

//   // Show toast
//   const showToast = (message, type) => {
//     setToast({ message, type, visible: true });
//   };

//   // Close toast
//   const closeToast = () => {
//     setToast({ ...toast, visible: false });
//   };

//   // Add product to cart
//   const addToCart = async (itemId, size) => {
//     if (!size) {
//       showToast("Select Product Size", "error");
//       return;
//     }

//     let cartData = structuredClone(cartItems);

//     if (cartData[itemId]) {
//       if (cartData[itemId][size]) {
//         cartData[itemId][size] += 1;
//       } else {
//         cartData[itemId][size] = 1;
//       }
//     } else {
//       cartData[itemId] = {};
//       cartData[itemId][size] = 1;
//     }
//     setCartItems(cartData);

//     if (token) {
//       try {
//         await axios.post(`${backendUrl}/api/cart/add`, { itemId, size }, { headers: { token } });
//         showToast("Added to cart successfully!", "success");
//       } catch (error) {
//         console.error(error);
//         showToast(error.message, "error");
//       }
//     } else {
//       showToast("Added to cart successfully!", "success");
//     }
//   };

//   const getCartCount = () => {
//     let totalCount = 0;
//     for (const items in cartItems) {
//       for (const item in cartItems[items]) {
//         if (cartItems[items][item] > 0) {
//           totalCount += cartItems[items][item];
//         }
//       }
//     }
//     return totalCount;
//   };

//   const updateQuantity = async (itemId, size, quantity) => {
//     let cartData = structuredClone(cartItems);
//     cartData[itemId][size] = quantity;
//     setCartItems(cartData);

//     if (token) {
//       try {
//         await axios.post(`${backendUrl}/api/cart/update`, { itemId, size, quantity }, { headers: { token } });
//       } catch (error) {
//         console.error(error);
//         showToast(error.message, "error");
//       }
//     }
//   };

//   const getCartAmount = () => {
//     let totalAmount = 0;
//     for (const items in cartItems) {
//       const itemInfo = products.find((product) => product._id === items);
//       for (const item in cartItems[items]) {
//         if (cartItems[items][item] > 0) {
//           totalAmount += itemInfo.price * cartItems[items][item];
//         }
//       }
//     }
//     return totalAmount;
//   };

//   const getProductsData = async () => {
//     try {
//       const response = await axios.get(`${backendUrl}/api/product/list`);
//       if (response.data.success) {
//         setProducts(response.data.products.reverse());
//       } else {
//         showToast(response.data.message, "error");
//       }
//     } catch (error) {
//       console.error(error);
//       showToast(error.message, "error");
//     }
//   };

//   const getUserCart = async (token) => {
//     try {
//       const response = await axios.post(`${backendUrl}/api/cart/get`, {}, { headers: { token } });
//       if (response.data.success) {
//         setCartItems(response.data.cartData);
//       }
//     } catch (error) {
//       console.error(error);
//       showToast(error.message, "error");
//     }
//   };

//   useEffect(() => {
//     getProductsData();
//   }, []);

//   useEffect(() => {
//     if (!token && localStorage.getItem("token")) {
//       setToken(localStorage.getItem("token"));
//       getUserCart(localStorage.getItem("token"));
//     }
//     if (token) {
//       getUserCart(token);
//     }
//   }, [token]);

//   const fetchUserProfile = async (token) => {
//     try {
//       const response = await axios.get(`${backendUrl}/api/user/profile`, { headers: { token } });
//       if (response.data.success) {
//         setUserData(response.data.user);
//       } else {
//         showToast(response.data.message, "error");
//       }
//     } catch (error) {
//       console.error(error);
//       showToast("Failed to fetch user data.", "error");
//     }
//   };

//   useEffect(() => {
//     if (token) {
//       fetchUserProfile(token); // Fetch user data when token is available
//     }
//   }, [token]);

//   const value = {
//     products,
//     currency,
//     delivery_fee,
//     search,
//     setSearch,
//     showSearch,
//     setShowSearch,
//     cartItems,
//     addToCart,
//     setCartItems,
//     getCartCount,
//     updateQuantity,
//     getCartAmount,
//     navigate,
//     backendUrl,
//     setToken,
//     token,
//     userData,
//   };

//   return (
//     <>
      
//       <ShopContext.Provider value={value}>{props.children}</ShopContext.Provider>

//       {toast.visible && <Toast message={toast.message} type={toast.type} onClose={closeToast} />}
//     </>
//   );
// };

// export default ShopContextProvider;


import { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Toast from "../pages/Tost"; // Import your Toast component
export const ShopContext = createContext();
const ShopContextProvider = (props) => {
  const currency = "₹";
  const delivery_fee = 0;
  const backendUrl = import.meta.env.VITE_BACKEND_URL; // Backend URL from environment
  const [search, setSearch] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [cartItems, setCartItems] = useState({});
  const [products, setProducts] = useState([]);
  const [token, setToken] = useState("");
  const [userData, setUserData] = useState(null); // Add userData state
  const [toast, setToast] = useState({ message: "", type: "", visible: false }); // Toast state
  const [coupon, setCoupon] = useState('');
  const navigate = useNavigate();
  // Show toast
  const showToast = (message, type) => {
    setToast({ message, type, visible: true });
  };
  // Close toast
  const closeToast = () => {
    setToast({ ...toast, visible: false });
  };
  // Add product to cart
  // const addToCart = async (itemId, size, color) => {     
  //   if (!size) {
  //     showToast("Select Product Size", "error");
  //     return;
  //   }
  //   if (!color) {
  //     showToast("Select Product Color", "error");
  //     return;
  //   }
  //   let cartData = structuredClone(cartItems);
  //   if (!cartData[itemId]) {
  //     cartData[itemId] = {};
  //   }
  //   if (!cartData[itemId][size]) {
  //     cartData[itemId][size] = {};
  //   }
  //   if (cartData[itemId][size][color]) {
  //     cartData[itemId][size][color] += 1;
  //   } else {
  //     cartData[itemId][size][color] = 1;
  //   }
  //   setCartItems(cartData);
  //   if (token) {
  //     try {
  //       await axios.post(
  //         `${backendUrl}/api/cart/add`,
  //         { itemId, size, color },
  //         { headers: { token } }
  //       );
  //       showToast("Added to cart successfully!", "success");
  //     } catch (error) {
  //       console.error(error);
  //       showToast(error.message, "error");
  //     }
  //   } else {
  //     showToast("Added to cart successfully!", "success");
  //   }
  // };

  const addToCart = async (itemId, size, color) => {     
    if (!size) {
      showToast("Select Product Size", "error");
      return;
    }
    if (!color) {
      showToast("Select Product Color", "error");
      return;
    }
    let cartData = structuredClone(cartItems);
    if (!cartData[itemId]) {
      cartData[itemId] = {};
    }
    // Ensure cartData[itemId][size] is an object, not a number
    if (!cartData[itemId][size] || typeof cartData[itemId][size] !== "object") {
      cartData[itemId][size] = {}; 
    }

    if (cartData[itemId][size][color]) {
      cartData[itemId][size][color] += 1;
    } else {
      cartData[itemId][size][color] = 1;
    }

    setCartItems(cartData);

    if (token) {
      try {
        await axios.post(
          `${backendUrl}/api/cart/add`,
          { itemId, size, color },
          { headers: { token } }
        );
         await getUserCart(token); // ✅ keep frontend in sync
         showToast("Added to cart successfully!", "success");
      } catch (error) {
        console.error(error);
        showToast(error.message, "error");
      }
    } else {
      showToast("Added to cart successfully!", "success");
    }
};


  const getCartCount = () => {
    let totalCount = 0;
  
    for (const itemId in cartItems) {
      const sizes = cartItems[itemId];
      for (const size in sizes) {
        const colors = sizes[size];
        for (const color in colors) {
          totalCount += colors[color]; // Add the quantity for each color
        }
      }
    }
  
    return totalCount;
  };
  



  const updateQuantity = async (itemId, size, color, quantity) => {
    let cartData = structuredClone(cartItems);

    // Ensure cartData[itemId] is an object
    if (typeof cartData[itemId] !== "object") {
        cartData[itemId] = {};
    }

    // Ensure cartData[itemId][size] is an object
    if (typeof cartData[itemId][size] !== "object") {
        cartData[itemId][size] = {};
    }

    if (quantity === 0) {
        delete cartData[itemId][size][color]; // Remove the specific color
        
        // If no colors remain, remove the size
        if (Object.keys(cartData[itemId][size]).length === 0) {
            delete cartData[itemId][size];
        }

        // If no sizes remain, remove the item
        if (Object.keys(cartData[itemId]).length === 0) {
            delete cartData[itemId];
        }
    } else {
        cartData[itemId][size][color] = quantity;
    }

    setCartItems(cartData);0

    if (token) {
        try {
            await axios.post(
                `${backendUrl}/api/cart/update`,
                { itemId, size, color, quantity },
                { headers: { token } }
            );
        } catch (error) {
            console.error(error);
            showToast(error.message, "error");
        }
    }
};



  



  // const getCartAmount = () => {
  //   let totalAmount = 0;
  
  //   for (const items in cartItems) {
  //     // Find the product information for the current item
  //     const itemInfo = products.find((product) => product._id === items);
  //     if (!itemInfo) {
  //       console.error(`Product with ID ${items} not found`);
  //       continue; // Skip this item if product data is missing
  //     }
  
  //     // Loop through sizes for the current item
  //     for (const size in cartItems[items]) {
  //       const sizeData = cartItems[items][size];
  
  //       // Loop through colors for the current size
  //       for (const color in sizeData) {
  //         const quantity = sizeData[color];
  //         if (quantity > 0) {
  //           totalAmount += itemInfo.price * quantity;
  //         }
  //       }
  //     }
  //   }
  
  //   return totalAmount;
  // };
  

//   const getCartAmount = () => {
//     let totalAmount = 0;
  
//     for (const items in cartItems) {
//         const itemInfo = products.find((product) => product._id === items);
//         if (!itemInfo) {
//             console.error(`Product with ID ${items} not found`);
//             continue;
//         }

//         for (const size in cartItems[items]) {
//             const sizeData = cartItems[items][size];

//             for (const color in sizeData) {
//                 const quantity = sizeData[color];
//                 if (quantity > 0) {
//                     totalAmount += itemInfo.price * quantity;
//                 }
//             }
//         }
//     }

//     // Get cart item count
//     const itemCount = getCartCount();

//     // Define discount percentages based on item count
//     let discountPercentage = 0;
//     if (itemCount === 1) discountPercentage = 10;
//     else if (itemCount === 2) discountPercentage = 15;
//     else if (itemCount === 3) discountPercentage = 20;
//     else if (itemCount === 4) discountPercentage = 20;
//     // else if (itemCount === 4) discountPercentage = 20;
//     if (itemCount === 5) {
//       discountPercentage = 25;
//   } else if (itemCount > 5 && itemCount < 10) {
//       discountPercentage = 25;
//   } else if (itemCount >= 10) {
//       discountPercentage = 30;
//   }

//     // Calculate discount amount
//     const discountAmount = (totalAmount * discountPercentage) / 100;

//     return { totalAmount, discountAmount };
// };



//  const getCartAmount = () => {
//     let totalAmount = 0;

//     for (const items in cartItems) {
//       const itemInfo = products.find((product) => product._id === items);
//       if (!itemInfo) continue;

//       for (const size in cartItems[items]) {
//         for (const color in cartItems[items][size]) {
//           const quantity = cartItems[items][size][color];
//           if (quantity > 0) {
//             totalAmount += itemInfo.price * quantity;
//           }
//         }
//       }
//     }

//     const itemCount = getCartCount();

//     let discountPercentage = 0;
//     if (itemCount === 1) discountPercentage = 0;
//     else if (itemCount === 2) discountPercentage = 0;
//     else if (itemCount <= 4) discountPercentage = 0;
//     else if (itemCount < 10) discountPercentage = 0;
//     else discountPercentage = 0;

//     let discountAmount = (totalAmount * discountPercentage) / 100;

//     // ✅ Apply extra 10% if coupon is Flat10
//     if (coupon.toLowerCase() === 'FLAT10') {
//       const extraDiscount = (totalAmount * 10) / 100;
//       discountAmount += extraDiscount;
//     }

//     return { totalAmount, discountAmount };
//   };


const getCartAmount = () => {
  let totalAmount = 0;

  for (const items in cartItems) {
    const itemInfo = products.find((product) => product._id === items);
    if (!itemInfo) continue;

    for (const size in cartItems[items]) {
      for (const color in cartItems[items][size]) {
        const quantity = cartItems[items][size][color];
        if (quantity > 0) {
          totalAmount += itemInfo.price * quantity;
        }
      }
    }
  }

  // const itemCount = getCartCount();
  let discountAmount = 0;

  // Flat10 logic
  if (coupon.trim().toLowerCase() === "flat10") {
    discountAmount = (totalAmount * 10) / 100;
  }

  // B2 logic
  else if (coupon.trim().toLowerCase() === "buy2") {
    let oversizedCount = 0;
    let oversizedTotal = 0;

    for (const items in cartItems) {
      const itemInfo = products.find((product) => product._id === items);
      if (!itemInfo) continue;

      if (itemInfo.category?.toLowerCase() === "oversized t-shirts") {
        for (const size in cartItems[items]) {
          for (const color in cartItems[items][size]) {
            const quantity = cartItems[items][size][color];
            oversizedCount += quantity;
            oversizedTotal += itemInfo.price * quantity;
          }
        }
      }
    }

    // ✅ Only apply B2 discount if exactly 2 oversized t-shirts
    if (oversizedCount === 2 && oversizedTotal === 899 * 2) {
      totalAmount = 1500;
      discountAmount = 0;
    } else {
      // If not matching, remove coupon automatically
      setCoupon("");
    }
  }

  return { totalAmount, discountAmount };
};


  

  const getProductsData = async () => {

    try {

      const response = await axios.get(`${backendUrl}/api/product/list`);

      if (response.data.success) {

        setProducts(response.data.products.reverse());

      } else {

        showToast(response.data.message, "error");

      }

    } catch (error) {

      console.error(error);

      showToast(error.message, "error");

    }

  };



  const getUserCart = async (token) => {

    try {

      const response = await axios.post(`${backendUrl}/api/cart/get`, {}, { headers: { token } });

      if (response.data.success) {

        setCartItems(response.data.cartData);

      }

    } catch (error) {

      console.error(error);

      showToast(error.message, "error");

    }

  };

const fetchUserProfile = async (token) => {
  try {
    const response = await axios.get(`${backendUrl}/api/user/profile`, { headers: { token } });

    if (response.data.success) {
      setUserData(response.data.user);
    } else {
      // User deleted / session expired
      setUserData(null);
      setToken("");
      localStorage.removeItem("token");
      showToast("Session expired or user deleted. Login again.", "error");
      navigate("/login");
    }
  } catch (error) {
    setUserData(null);
    setToken("");
    localStorage.removeItem("token");
    showToast("Session expired or user deleted. Login again.", "error");
    navigate("/login");
  }
};
  // useEffect(() => {

  //   if (token) {

  //     fetchUserProfile(token); // Fetch user data when token is available

  //   }


  // }, [token]);



  useEffect(() => {

    getProductsData();

  }, []);

useEffect(() => {
  const localToken = localStorage.getItem("token");
  if (localToken && !token) {
    setToken(localToken); // trigger token dependent effects
     getUserCart(localToken); // ✅ fetch cart right away
    fetchUserProfile(localToken);
  }

  if (token) {
    fetchUserProfile(token); // ✅ fetch user data from backend
    getUserCart(token);      // ✅ fetch cart from backend
  }
}, [token]);

  // useEffect(() => {

  //   if (!token && localStorage.getItem("token")) {

  //     setToken(localStorage.getItem("token"));

  //     getUserCart(localStorage.getItem("token"));

  //   }

  //   if (token) {

  //     getUserCart(token);

  //   }

  // }, [token]);



  // const fetchUserProfile = async (token) => {
  //   try {
  //     const response = await axios.get(`${backendUrl}/api/user/profile`, { headers: { token } });
  //     if (response.data.success) {
  //       setUserData(response.data.user);
  //     } else {
  //       showToast(response.data.message, "error");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     showToast("Failed to fetch user data.", "error");
  //   }
  // };

// const fetchUserProfile = async (token) => {
//   try {
//     const response = await axios.get(`${backendUrl}/api/user/profile`, { headers: { token } });

//     if (response.data.success) {
//       setUserData(response.data.user);
//     } else {
//       // User not found → logout
//       setUserData(null);
//       setToken("");
//       localStorage.removeItem("token");
//       showToast("User no longer exists. Please login again.", "error");
//       navigate("/login"); // Redirect to login page
//     }
//   } catch (error) {
//     console.error(error);
//     setUserData(null);
//     setToken("");
//     localStorage.removeItem("token");
//     showToast("Session expired or user deleted. Login again.", "error");
//     navigate("/login");
//   }
// };



  const value = {

    products,

    currency,

    delivery_fee,

    search,

    setSearch,

    showSearch,

    setShowSearch,

    cartItems,

    addToCart,

    setCartItems,

    getCartCount,

    updateQuantity,

    getCartAmount,

    navigate,

    backendUrl,

    setToken,

    token,

    userData,
    coupon,
        setCoupon,
        getUserCart,
        

  };



  return (

    <>

      

      <ShopContext.Provider value={value}>{props.children}</ShopContext.Provider>



      {toast.visible && <Toast message={toast.message} type={toast.type} onClose={closeToast} />}

    </>

  );

};



export default ShopContextProvider;


